import { css } from "lit";

export const holloInlineRecorderStyles = css`
  /* Inline row that slots into your composer without changing its grid */
  .hollo-rec-row {
    grid-column: 1 / -1; /* span all 3 columns of composer */
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 12px;
    background: #131313;
    border: none;
    border-radius: 999px;
    padding: 9px 16px;
    color: #fff;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
  }

  .hollo-left-recorder {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
    justify-content: space-between;
  }

  .hollo-dot {
    width: 10px;
    height: 10px;
    border-radius: 999px;
    background: #9ca3af;
  }
  .hollo-dot.hollo-red {
    background: #ef4444;
  }
  .hollo-dot.hollo-pulse {
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
    animation: pulse 1.5s infinite;
  }
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.6);
    }
    70% {
      box-shadow: 0 0 0 12px rgba(239, 68, 68, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
    }
  }

  .hollo-time {
    font-weight: 700;
    color: #ef4444; /* red */
    font-size: 14px;
    min-width: 48px;
    text-align: right;
  }

  .hollo-eq {
    display: grid;
    grid-template-columns: repeat(16, 3px);
    gap: 3px;
    height: 22px;
  }
  .hollo-bar {
    display: block;
    align-self: end;
    width: 100%;
    height: 4%; /* overridden inline */
    background: #ef4444; /* red bars */
    opacity: 0.9;
    border-radius: 2px;
    transition: height 120ms linear;
  }

  .hollo-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .hollo-btn {
    border: none;
    cursor: pointer;
  }
  .hollo-btn.hollo-icon {
    width: 34px;
    height: 34px;
    border-radius: 999px;
    display: grid;
    place-items: center;
    background: transparent;
    color: #fff;
  }
  .hollo-btn.hollo-icon.hollo-cancel {
    color: #ef4444; /* red X */
  }
  .hollo-btn.hollo-icon.hollo-confirm {
    color: #fff; /* white check */
  }
  /* remove old pill buttons */
`;
